import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { API_CONFIG } from '../../../config/api.config';
import {
  CreateQuoteRequest,
  CreateQuoteResponse,
  UpdateQuoteRequestCompatible,
  UpdateQuoteResponse,
} from '../../../domain/interfaces/quote/quote.interface';

@Injectable({ providedIn: 'root' })
export class QuoteService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  createQuote(request: CreateQuoteRequest): Observable<CreateQuoteResponse> {
    return this.http.post<CreateQuoteResponse>(
      `${this.baseUrl}${API_CONFIG.ENDPOINTS.CREAR_COTIZACION_SALUD_ANIMAL}`,
      request,
    );
  }

  getQuote(quoteId: string): Observable<CreateQuoteResponse> {
    return this.http.get<CreateQuoteResponse>(
      `${this.baseUrl}${API_CONFIG.ENDPOINTS.CREAR_COTIZACION_SALUD_ANIMAL}/${quoteId}`,
    );
  }

  updateQuote(quoteId: string, request: UpdateQuoteRequestCompatible): Observable<UpdateQuoteResponse> {
    return this.http.put<UpdateQuoteResponse>(
      `${this.baseUrl}${API_CONFIG.ENDPOINTS.ACTUALIZAR_COTIZACION_SALUD_ANIMAL}/${quoteId}`,
      request,
    );
  }
}
